var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'settings-accounting-tax_groups',"addButton":false,"addLink":true,"addLinkLabel":((_vm.$t('add_new')) + " " + (_vm.$t('vat_product_categories'))),"rightMenu":[
    {
      text: this.$t('vat_report'),
      value: 'vat_report'
    },
    {
      text: this.$t('load_default'),
      value: 'load_default'
    }
  ]},on:{"add_click":_vm.onAddClick,"menuClick":_vm.onRightMenuClick}},[_c('DList',{attrs:{"items":_vm.accountingSettingsData.vat_categories,"primaryKey":'vat_category_id',"labelKey":'vat_category_name',"clickable":true},on:{"delete":_vm.onItemDelete,"item_click":_vm.onItemClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }